const conditions = () => {
  return [{ assetClass: 'object.asset-class.options.kapitalgeber' }, { typeOfFinancing: 'object.type-of-financing.options.mezzanine-loan' }]
}

export default conditions
